// Returns the gender switch and cards for the slider
export const BrowsePageService_GetGenderedCardsLazy = () =>
  import("./service.grpc").then((m) => m.BrowsePageService_GetGenderedCards);
BrowsePageService_GetGenderedCardsLazy.method =
  "aysa_api.services.browse_page.v1.BrowsePageService/GetGenderedCards" as const;

// Returns category tiles
export const BrowsePageService_GetBrowseCategoriesLazy = () =>
  import("./service.grpc").then((m) => m.BrowsePageService_GetBrowseCategories);
BrowsePageService_GetBrowseCategoriesLazy.method =
  "aysa_api.services.browse_page.v1.BrowsePageService/GetBrowseCategories" as const;

// Returns USPs
export const BrowsePageService_GetBrowseUSPsLazy = () =>
  import("./service.grpc").then((m) => m.BrowsePageService_GetBrowseUSPs);
BrowsePageService_GetBrowseUSPsLazy.method =
  "aysa_api.services.browse_page.v1.BrowsePageService/GetBrowseUSPs" as const;

// returns one of the possible banners on browse page
export const BrowsePageService_GetBrowseBannerLazy = () =>
  import("./service.grpc").then((m) => m.BrowsePageService_GetBrowseBanner);
BrowsePageService_GetBrowseBannerLazy.method =
  "aysa_api.services.browse_page.v1.BrowsePageService/GetBrowseBanner" as const;
